import { ReactElement, ReactNode } from "react";
import * as S from "./FundBox.styled";

const FundBox = ({ children }: { children: ReactNode }): ReactElement => {
  return <S.Container>{children}</S.Container>;
};

export default FundBox;
